import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-99bc2a1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo-desktop",
  alt: "logo-decktop",
  src: _imports_0
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "header__content--menu"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__menu--circle" }, "1"),
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Номенклатура")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__menu--circle" }, "2"),
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Правила упаковки")
], -1))
const _hoisted_7 = {
  key: 1,
  class: "header__menu--link no-select"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__menu--circle" }, "2"),
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Правила упаковки")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__menu--circle" }, "3"),
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Расчёты")
], -1))
const _hoisted_11 = {
  key: 3,
  class: "header__menu--link no-select"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__menu--circle" }, "3"),
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Расчёты")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "header__content--menu"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Номенклатура")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Правила упаковки")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "Расчёты")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__menu--item" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "header__menu--title" }, "История")
], -1))
const _hoisted_19 = { class: "header__btn-group" }
const _hoisted_20 = { class: "header__login--name" }
const _hoisted_21 = { class: "header__popover-container" }
const _hoisted_22 = { class: "link" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__divider" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_iconProfile = _resolveComponent("iconProfile")!
  const _component_ChangeEmailModal = _resolveComponent("ChangeEmailModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: { name: 'NomenclaturePage' } }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        (_ctx.user?.newbie && _ctx.isAuth?.is_active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'NomenclaturePage' },
                class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'NomenclaturePage' }])
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["class"]),
              (_ctx.isRulesEnabled)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { name: 'RulesPage' },
                    class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'RulesPage' }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
              (_ctx.isCalculationsEnabled)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: { name: 'CalculationsPage' },
                    class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'CalculationsPage' }])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            ]))
          : (_ctx.isAuth?.is_active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: { name: 'NomenclaturePage' },
                  class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'NomenclaturePage' }])
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: { name: 'RulesPage' },
                  class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'RulesPage' }])
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: { name: 'CalculationsPage' },
                  class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'CalculationsPage' }])
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_router_link, {
                  to: { name: 'LogsPage' },
                  class: _normalizeClass(["header__menu--link", { active: _ctx.route.name === 'LogsPage' }])
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.user?.email), 1),
          (_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "header__popover-wrapper",
                onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPopover = true)),
                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPopover = false))
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_iconProfile)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["header__popover", { visible: _ctx.showPopover }])
                  }, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showСhangePasswordModal())),
                      class: "header__popover-button link"
                    }, " Изменить пароль "),
                    (!_ctx.user?.is_active)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSubmitAccount())),
                          class: "header__popover-button link"
                        }, " Подтвердить аккаунт "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteModal())),
                      class: "header__popover-button link"
                    }, " Удалить аккаунт "),
                    _hoisted_23,
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                      class: "header__popover-button link"
                    }, " Выйти ")
                  ], 2)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ChangeEmailModal, { ref: "changePasswordRef" }, null, 512),
    _createVNode(_component_DeleteModal, {
      dataProps: _ctx.user,
      ref: "deleteModalRef",
      onSubmit: _ctx.remove
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Удалить аккаунт пользователя " + _toDisplayString(_ctx.user?.email) + "? ", 1)
      ]),
      _: 1
    }, 8, ["dataProps", "onSubmit"])
  ], 64))
}